/**
 * Een dossier nakijken tegen zijn eigen manifest. GL215 S3, Buzz spoor 1 E-licht deel 2.
 *
 * Het dossier komt uit het menu bij een gesprek ("Dossier (zip)"). Hier kies je zo'n zip, en de
 * dienst legt elk bestand tegen het manifest (`backend/services/dossier.py` `controleer`). De zin
 * eronder komt van de dienst en zegt ook wat het NIET bewijst: wie het dossier maakte.
 */
import { useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { useTaal } from "@/contexts/TaalContext";

export default function DossierControle() {
  const { t } = useTaal();
  const [uitslag, setUitslag] = useState(null);
  const [fout, setFout] = useState("");

  const kijkNa = async (e) => {
    const bestand = e.target.files && e.target.files[0];
    if (!bestand) return;
    setUitslag(null);
    setFout("");
    const vorm = new FormData();
    vorm.append("bestand", bestand);
    try {
      const r = await axios.post(`${API}/settings/dossier/controleer`, vorm);
      setUitslag(r.data);
    } catch {
      setFout(t("Nakijken is mislukt."));
    }
  };

  const lijst = (naam, items) => (items && items.length > 0 ? (
    <p className="text-xs text-muted-foreground break-words" data-testid={`dossier-${naam}`}>
      {t(naam)}: {items.join(", ")}
    </p>
  ) : null);

  return (
    <div className="border rounded-lg p-4 space-y-3" data-testid="dossier-controle">
      <h4 className="font-medium text-sm">{t("Dossier nakijken")}</h4>
      <p className="text-xs text-muted-foreground">
        {t("Kies een dossier (zip) uit het menu bij een gesprek. Elk bestand wordt tegen het manifest gelegd.")}
      </p>
      <input type="file" accept=".zip,application/zip" onChange={kijkNa} data-testid="dossier-bestand"
             className="block text-xs" />
      {uitslag && (
        <div className="space-y-1" data-testid="dossier-uitslag">
          <p className={`text-sm ${uitslag.klopt ? "" : "text-destructive"}`} data-testid="dossier-zin">{uitslag.zin}</p>
          {lijst("gewijzigd", uitslag.gewijzigd)}
          {lijst("ontbreekt", uitslag.ontbreekt)}
          {lijst("erbij gekomen", uitslag.extra)}
        </div>
      )}
      {fout && <p className="text-xs text-destructive">{fout}</p>}
    </div>
  );
}
